import createVueApp from '@phoenix/createVueApp';
import StoreSelectorModal from '@maison/components/store/StoreSelectorModal.vue';

const app = createVueApp({}, true);
app.component('StoreSelectorModal', StoreSelectorModal);
app.mount('#phoenix-store-selector-modal');
